import useForm from '@/core/hooks/useForm/useForm';

export default useForm;
